export default [
    {
        path: '/user/list/:filter?',
        name: 'user_list',
        component: () => import('@src/user/user-list'),
        meta: {
            title: 'Benutzer',
            role: 'ROLE_LIST_USER',
        },
    },
    {
        path: '/user/detail/:id',
        name: 'user_detail',
        props(route) {
            const props = { ...route.params };
            props.id = Number(props.id);

            return props;
        },
        component: () => import('@src/user/user-detail'),
        meta: {
            role: 'ROLE_SHOW_USER',
        },
    },

    {
        path: '/user/login-token/list/:filter?',
        name: 'user_login_token_list',
        component: () => import('@src/user/login-token'),
        meta: {
            title: 'Login Token',
            role: 'ROLE_LIST_USER_LOGIN_TOKEN',
        },
    },
    {
        path: '/user/login-token/create',
        name: 'user_login_token_create',
        component: () => import('@src/user/login-token-create'),
        meta: {
            title: 'Neues Tageslogin erstellen',
            role: 'ROLE_PRINT_USER_LOGIN_TOKEN',
        },
    },
];
